import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { loadIntervention } from "../../redux/intervention/interventionActions";
import { withRouter } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { getCurrentFunctionName } from "../../performanceModeManager";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class InterventionAlreadyInProgressModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: props.opened,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;
        modifiedState.modalOpenned = nextProps.opened;
        return modifiedState;
    }

    shouldComponentUpdate(nextProps) {
        return this.props.opened !== nextProps.opened;
    }

    close() {
        this.setState({ modalOpenned: false });
        this.props.closeModal();
    }

    goToIntervention() {
        // this.props.loadIntervention(this.props.interventionInProgress);
        // this.props.history.push("/interventions/intervention");
        this.close();
        this.props.openStartInterventionModal();
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        if (!this.props.interventionInProgress) return null;

        let message = "Impossible de démarrer ou de créer un OT tant qu'il y a un OT en cours";

        if (this.props.imputationMode) {
            if (typeof this.props.forceEndIntervention === "function") {
                message = "Il y a un OT en cours, impossible de le modifier dans la saisie des temps";
            } else {
                message =
                    "Impossible de modifier ou de créer un roulage ou une imputation tant qu'il y a un OT en cours";
            }
        }

        if (this.props.interventionInProgress.name)
            message = message.concat(" (" + this.props.interventionInProgress.name + ")");

        return (
            <Dialog
                aria-labelledby="simple-dialog-title"
                open={this.state.modalOpenned}
                onClose={this.close.bind(this)}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            {"OT en cours"}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className="full_size control-margin-top">{message}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.goToIntervention.bind(this)} color="primary">
                        {"Mettre en pause et continuer"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadIntervention: (intervention) => dispatch(loadIntervention(intervention)),
    };
};

export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(InterventionAlreadyInProgressModal);
